import navbarSearchAndPinList from '@/layouts/components/navbar/navbarSearchAndPinList'
import themeConfig, { colors }  from '@/../themeConfig.js'
import store from './store.js'

// /////////////////////////////////////////////
// Helper
// /////////////////////////////////////////////

// *From Auth - Data will be received from auth provider
const userDefaults = {
  email: 'scratchoff@authorizelocal.com',
  exp: 0,
  iat: 0,
  _id: '',
  name: 'Scratch Off',
  profilePicture: '',
  yelp: null,
  google_places : null,
  instagram: null
}


// Check if device is touch device
// This is used to remove perfect scrollbar from touch devices
// Using Dynamic components
const is_touch_device = () => {
  const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ')
  const mq = function (query) {
    return window.matchMedia(query).matches
  }

  if (('ontouchstart' in window) || window.DocumentTouch) {
    return true
  }

  // include the 'heartz' as a way to have a non matching MQ to help terminate the join
  // https://git.io/vznFH
  const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('')
  return mq(query)
}


// /////////////////////////////////////////////
// State
// /////////////////////////////////////////////

const state = {
  AppActiveUser           : userDefaults,
  bodyOverlay             : false,
  eventImage              : '',
  eventImagePreview              : '',
  showPopup               : false,
  showImagePopup          : false,
  isVerticalNavMenuActive : true,
  is_touch_device         : is_touch_device(),
  mainLayoutType          : themeConfig.mainLayoutType || 'vertical',
  navbarSearchAndPinList,
  reduceButton            : themeConfig.sidebarCollapsed,
  verticalNavMenuWidth    : 'default',
  verticalNavMenuItemsMin : false,
  scrollY                 : 0,
  starredPages            : navbarSearchAndPinList['pages'].data.filter((page) => page.is_bookmarked),
  theme                   : themeConfig.theme || 'light',
  themePrimaryColor       : colors.primary,

  // Can be used to get current window with
  // Note: Above breakpoint state is for internal use of sidebar & navbar component
  windowWidth: null,

  userCapable: (user) => {
    let result = false
    if (user.permissionLevel === 2048) {
      result = true
    } else {
      try {
        user.subscriptions.map(sub => {
          if (['active', 'trialing'].includes(sub.status) && sub.plan.product.id === 'prod_LxaiP3NvLRaWld') {
            result = true
          }
        })
      } catch (e) {
        console.log(e)
      }
    }

    return result
  },

  isUserLoggedIn: async () => {
    let isAuthenticated = false

    await store.dispatch('checkTokenValid').then((response) => {
      if (response.status === 200) {
        isAuthenticated = true
      } else {
        isAuthenticated = false
      }
    }).catch(error => {
      console.log(error)
      isAuthenticated = false
    })
    return isAuthenticated
  },
  token_valid: false,
  pass: false,
  audio: new Audio(require('../assets/sounds/scratch_sound.mp3')),
  posts: [],
  users: [],
  interactions: [],
  interactionsAll: [],
  selected_services: [],
  post_detail: null,
  campaign_theme: null,
  editing_now: null
}

export default state
